import InputStatusModule from "./inputStatusModule";

export default InputStatusModule;
